<template>
  <div class="bigScreen-form">
    <div style="height: 5%;width: 100%;">
            <div class="bigScreen-header">
<!--            <span class="el-dropdown-link" style="color: white;font-size: 15px">{{this.$store.state.userInfo.showName}}-->
            <span class="el-dropdown-link" style="color: white;font-size: 15px">进入系统
                  </span> <a @click="goBack" style="cursor: pointer;font-size: 15px">&nbsp;&nbsp;<img
              src="../../assets/img/bigScreen/jt1.png"></a>
            </div>
    </div>
    <div class="bigScreen-content">
      <div class="bigScreen-left">
        <!--科技特派员情况-->
        <div class="bigScreen-tech-personnel">
          <div class="tech-personnel-title">{{showName}}科技特派员情况</div>
          <div class="tech-personnel-stats">
            <div class="stat-item">
              <span class="stat-label">省级科技特派员</span>
              <span class="stat-value">{{ techPersonnelStats.provincial }}个</span>
            </div>
            <div class="stat-item">
              <span class="stat-label">市级科技特派员</span>
              <span class="stat-value">{{ techPersonnelStats.municipal }}个</span>
            </div>
            <div class="stat-item">
              <span class="stat-label">区级科技特派员</span>
              <span class="stat-value">{{ techPersonnelStats.district }}个</span>
            </div>
<!--            <div class="stat-item">-->
<!--              <span class="stat-label">乡级科技特派员</span>-->
<!--              <span class="stat-value">{{ techPersonnelStats.township }}个</span>-->
<!--            </div>-->
            <div class="stat-item">
              <span class="stat-label">科技特派员团队</span>
              <span class="stat-value">{{ techPersonnelStats.team }}个</span>
            </div>
            <div class="stat-item">
              <span class="stat-label">法人科技特派员</span>
              <span class="stat-value">{{ techPersonnelStats.legalPerson }}个</span>
            </div>
          </div>
        </div>

        <!--地图-->
        <div class="bigScreen-map" style="position: relative">

          <big-screen-map @changeCity="changeCity" ref="bigScreenMap"
                          style="width: 100%;height:100%;z-index: 99"></big-screen-map>
        </div>

      </div>
      <!--      右上-->
      <div class="bigScreen-right" v-show="showName === '延平区'">
        <!--科技成果展示-->
        <div class="bigScreen-price1">
          <tech-achievements style="width: 100%;height:100%"></tech-achievements>
        </div>
        <!--右下-->
        <div class="bigScreen-handle1">
          <achievement-show style="width: 100%;height:100%"></achievement-show>
        </div>
      </div>

      <div class="bigScreen-right" v-show="showName !== '延平区'">
        <!--科技成果展示-->
<!--        <div class="bigScreen-price2">-->
<!--          <service-units-->
<!--            :cityName="showName"-->
<!--            :cityId="selectedCityId"-->
<!--            style="width: 100%;height:100%"-->
<!--          ></service-units>-->
<!--        </div>-->
        <!--右下-->
        <div class="bigScreen-handle3">
          <specialists
            :cityName="showName"
            :cityId="selectedCityId"
            style="width: 100%;height:100%"
          ></specialists>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import BigScreenMap from './components/bigScreenMap';
import TechAchievements from './components/techAchievements';
import AchievementShow from './components/achievementShow';
// import ServiceUnits from './components/ServiceUnits';
import Specialists from './components/Specialists';
import TechPersonnelController from '../../api/Controller/TechPersonnelController';
import { getTechPersonnelStaticData } from '../../utils/staticData';
// import PartySite from '@/views/bigScreen/components/partySite';
// import { AssetsReportStatisticsController } from '@/api';

export default {
  name: 'index',
  components: {
    TechAchievements,
    AchievementShow,
    // BigScreenAssetBar,
    // AgriculturalProducts,
    // PartySite,
    // ProjectPlan,
    // AgriculturalCooperatives,
    BigScreenMap,
    // ServiceUnits,
    Specialists
    // BaseCase
  },
  props: {
    cityName: {
      type: String,
      default: '延平区'
    }
  },
  data () {
    return {
      activeName: 'first',
      activeName1: 'first',
      showName: '延平区',
      selectedCityId: 'YP000000',
      totalPrice: {
        'totalPie': [2918.34, '亿元'],
        'assetPie': [2916.07, '亿元'],
        'stockPie': [2.06, '亿元'],
        'invisiblePie': [0.21, '亿元'],
        'pricePie': [19.86, '万元'],
        'handleBar': [16.88, '万元'],
        'pie': [7, '亿元']
      },
      techPersonnelStats: {
        provincial: 0,
        municipal: 0,
        district: 0,
        township: 0,
        team: 0,
        legalPerson: 0
      }
    }
  },
  computed: {},

  mounted () {
    // console.info(this.cityName)
    // this.initData('福建省')
    console.log('页面初始化，开始获取特派员数据，地区:', this.showName);
    // 延迟执行，确保组件完全初始化
    setTimeout(() => {
      this.fetchTechPersonnelStats(this.showName);
    }, 100);
  },
  methods: {
    // 获取科技特派员统计数据
    fetchTechPersonnelStats (townStreet) {
      console.log('开始获取科技特派员统计数据，地区:', townStreet);
      // 调用后端 API 获取实际数据
      TechPersonnelController.getStats(this, { townStreet })
        .then(res => {
          console.log('科技特派员统计数据:', res);
          if (res.data) {
            // 省级和市级使用后台数据，区级、乡级、团队和法人使用静态数据
            const staticData = getTechPersonnelStaticData(townStreet);
            const statsData = {
              provincial: res.data.provincial || 0,
              municipal: res.data.municipal || 0,
              district: res.data.district || 0,
              township: staticData.township,
              team: staticData.team,
              legalPerson: staticData.legalPerson
            };
            this.techPersonnelStats = statsData;
            console.log('更新后的特派员数据:', this.techPersonnelStats);
          } else {
            console.warn('获取到的特派员数据格式不正确:', res);
          }
        })
        .catch(error => {
          console.error('获取科技特派员统计数据失败:', error);
          // 使用静态数据作为兜底
          const staticData = getTechPersonnelStaticData(townStreet);
          this.techPersonnelStats = {
            provincial: 0,
            municipal: 0,
            district: 0,
            township: staticData.township,
            team: staticData.team,
            legalPerson: staticData.legalPerson
          };
          console.log('使用静态数据作为兜底:', this.techPersonnelStats);
        })
    },
    changeCity (cityName, cityId) {
      console.log('展示地市：', cityName, cityId)
      this.showName = cityName;
      this.selectedCityId = cityId;
      // 当地区变化时，重新获取科技特派员统计数据
      this.fetchTechPersonnelStats(cityName);
    },
    handleClick (tab, event) {

    },
    goBack () {
      // 返回上一页
      this.$router.go(-1);
    }
  }

}
</script>

<!--suppress CssInvalidPropertyValue -->
<style scoped lang="scss">
  .bigScreen-form {
    width: 100%;
    height: 100vh;
    background: #292D36;
    background: url(../../assets/img/bigScreen/bg.jpg) no-repeat;
    background-size: cover;
    min-height: 620px;
  }

  .bigScreen-content {
    /*padding: 0.5%;*/
    width: 100%;
    height: 90%;
    top: 9%;
    position: absolute;
    display: flex;
  }

  .bigScreen-header {
    position: absolute;
    right: 2%;
    left:2%;
    top: 30px;
    color: white;
    font-size: 13px;
  }

  .bigScreen-left {
    width: 60%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .bigScreen-tech-personnel {
    position: relative;
    width: 100%;
    height: 120px;
    min-height: 120px;
    max-height: 120px;
    margin: 0 0 1% 0;
    color: #fff;
    box-sizing: border-box;
    padding: 15px;
    z-index: 1000;
    flex-shrink: 0;
    /* 自定义背景样式 */
    background: linear-gradient(135deg, rgba(14, 46, 44, 0.95) 0%, rgba(1, 19, 13, 0.95) 100%);
    border: 1px solid rgba(115, 221, 255, 0.4);
    border-radius: 10px;
    box-shadow: 0 0 20px rgba(115, 221, 255, 0.3), inset 0 0 30px rgba(1, 19, 13, 0.5);
    overflow: hidden;
  }

  /* 装饰元素 */
  .bigScreen-tech-personnel::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: linear-gradient(90deg, transparent 0%, rgba(115, 221, 255, 0.8) 50%, transparent 100%);
  }

  .bigScreen-tech-personnel::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: linear-gradient(90deg, transparent 0%, rgba(115, 221, 255, 0.8) 50%, transparent 100%);
  }

  .tech-personnel-title {
    font-size: 19px;
    font-weight: bold;
    color: #ffd700;
    text-align: center;
    margin-bottom: 12px;
    text-shadow: 2px 2px 4px #2c2c2c, 0 0 10px #ffd700, 0 0 20px #ffd700;
    -webkit-text-stroke: 1px #333;
    position: relative;
    display: inline-block;
    left: 50%;
    transform: translateX(-50%);
    padding: 0 20px;
    background: linear-gradient(90deg, transparent 0%, rgba(255, 215, 0, 0.2) 50%, transparent 100%);
    border-radius: 20px;
  }

  .tech-personnel-stats {
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
    height: calc(100% - 50px);
  }

  .stat-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 120px;
    padding: 8px;
    border-radius: 6px;
    background: rgba(1, 19, 13, 0.5);
    border: 1px solid rgba(115, 221, 255, 0.2);
    transition: all 0.3s ease;
  }

  .stat-item:hover {
    background: rgba(115, 221, 255, 0.1);
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(115, 221, 255, 0.2);
  }

  .stat-label {
    font-size: 13px;
    color: #73DDFF;
    margin-bottom: 6px;
    font-weight: 500;
  }

  .stat-value {
    font-size: 18px;
    font-weight: bold;
    color: #e6a23c;
    text-shadow: 0 0 5px rgba(230, 162, 60, 0.5);
    transition: all 0.3s ease;
  }

  .stat-item:hover .stat-value {
    color: #f0b85c;
    transform: scale(1.05);
  }

  .bigScreen-map {
    position: relative;
    width: 100%;
    height: calc(85% - 1%);
    margin: 0;
    color: #fff;
    padding-right: 0;
    box-sizing: border-box;
    flex-shrink: 0;
  }

  .bigScreen-middle {
    width: 43%;
    height: 100%;
    padding: 0 0.5%;
  }

  .bigScreen-right {
    width: 40%;
    height: 100%;
  }

  .bigScreen-fourth {
    display: flex;
    justify-content: space-around;
    height: 90px;
    align-items: center;
    padding-top: 1%;
  }

  .bigScreen-select {
    position: relative;
    width: 100%;
    height: 36%;
    background-image: url(../../assets/img/bigScreen/mid_bottom.png);
    background-size: 100% 100%;
    margin: 0 0px 1% 0;
    color: #fff;
    float: left;
    padding-right: 10px;
    box-sizing: border-box;
  }

  .bigScreen-select > > > .el-tabs__item:hover {
    color: #ffffff !important;
    cursor: pointer;
  }

  .bigScreen-select > > > .el-tabs__item.is-active {
    /*color: #ffffff !important;*/

    background: linear-gradient(to bottom, #ffffff 25.53%, #66b1ff 84.52%);
    transition: all 0.5s;
    transition-timing-function: ease;
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent !important;
  }

  .bigScreen-select > > > .el-tabs__content {
    overflow: hidden;
    position: relative;
    width: 100%;
    height: calc(100% - 70px);
    padding: 0 0.5%;
  }

  .bigScreen-select > > > .el-tabs__item {
    padding: 0 40px;
    height: 50px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 50px;
    display: inline-block;
    list-style: none;
    font-size: 14px;
    font-weight: bold;
    color: #66b1ff !important;
    position: relative;
  }

  .bigScreen-select > > > .el-tabs__active-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 2px;
    background-color: #66b1ff;
    z-index: 1;
    -webkit-transition: -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    list-style: none;
  }

  .bigScreen-select > > > .el-tabs__nav-wrap::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    background-color: rgb(74, 100, 151);
    z-index: 1;
  }

  .bigScreen-select > > > .el-tabs {
    width: 100%;
    height: 100%;
    padding: 0 0.5%;
  }

  .bigScreen-select > > > .el-tab-pane {
    height: 100%;
  }

  .bigScreen-select > > > .el-tabs__header {
    padding: 0 40px 10px 50px;
    margin: 0px;
  }

  .bigScreen-handle > > > .el-tabs__item:hover {
    color: #ffffff !important;
    cursor: pointer;
  }

  .bigScreen-handle > > > .el-tabs__item.is-active {
    /*color: #ffffff !important;*/

    background: linear-gradient(to bottom, #ffffff 25.53%, #66b1ff 84.52%);
    transition: all 0.5s;
    transition-timing-function: ease;
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent !important;
  }

  .bigScreen-handle > > > .el-tabs__content {
    overflow: hidden;
    position: relative;
    width: 100%;
    height: calc(100% - 10px);
    padding: 0 0.5%;
  }

  .bigScreen-handle > > > .el-tabs__item {
    padding: 0 40px;
    height: 50px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 50px;
    display: inline-block;
    list-style: none;
    font-size: 14px;
    font-weight: bold;
    color: #66b1ff !important;
    position: relative;
  }

  .bigScreen-handle > > > .el-tabs__active-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 2px;
    background-color: #66b1ff;
    z-index: 1;
    -webkit-transition: -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    list-style: none;
  }

  .bigScreen-handle > > > .el-tabs__nav-wrap::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    background-color: rgb(74, 100, 151);
    z-index: 1;
  }

  .bigScreen-handle > > > .el-tabs {
    width: 100%;
    height: 100%;
    padding: 0 0.5%;
  }

  .bigScreen-handle > > > .el-tab-pane {
    height: 100%;
  }

  .bigScreen-handle > > > .el-tabs__header {
    padding: 0 40px 10px 50px;
    margin: 0px;
  }

  .bigScreen-one {
    background-image: url(../../assets/img/bigScreen/min-tip.png);
    background-size: 100% 100%;
    width: 24%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: start;
    padding-left: 5%;
    font-weight: bold;
  }

  .fourth-name {
    color: #66b1ff;
    font-size: 15px;
  }

  .fourth-price {
    color: #e6a23c;
    font-size: 25px;
  }

  .fourth-span {
    font-size: 12px;
  }

  .bigScreen-price2 {
    position: relative;
    width: 100%;
    height: 50%;
    background-image: url(../../assets/img/bigScreen/box_03.png);
    background-size: 100% 100%;
    margin: 0 0px 2% 0;
    color: #fff;
    float: left;
    padding-right: 10px;
    box-sizing: border-box;
  }

  .bigScreen-handle2 {
    position: relative;
    width: 100%;
    height: 50%;
    background-image: url(../../assets/img/bigScreen/box_03.png);
    background-size: 100% 100%;
    margin: 0 0px 2% 0;
    color: #fff;
    float: left;
    padding-right: 10px;
    box-sizing: border-box;
  }
  .bigScreen-handle3 {
    position: relative;
    width: 100%;
    height: 100%;
    //background-image: url(../../assets/img/bigScreen/box_03.png);
    background-size: 100% 100%;
    margin: 0 0px 2% 0;
    color: #fff;
    float: left;
    padding-right: 10px;
    box-sizing: border-box;
  }
  .bigScreen-price1 {
    position: relative;
    width: 100%;
    height: 50%;
    background-image: url(../../assets/img/bigScreen/box_03.png);
    background-size: 100% 100%;
    margin: 0 0px 2% 0;
    color: #fff;
    float: left;
    padding-right: 10px;
    box-sizing: border-box;
  }

  .bigScreen-handle1 {
    position: relative;
    width: 100%;
    height: 50%;
    background-image: url(../../assets/img/bigScreen/box_03.png);
    background-size: 100% 100%;
    margin: 0 0px 2% 0;
    color: #fff;
    float: left;
    padding-right: 10px;
    box-sizing: border-box;
  }

  .bigScreen-turn {
    position: relative;
    width: 100%;
    height: 32%;
    background-image: url(../../assets/img/bigScreen/tip.png);
    background-size: 100% 100%;
    margin: 0 0px 1% 0;
    color: #fff;
    float: left;
    padding-right: 10px;
    box-sizing: border-box;
  }

  .bigScreen-invisible {
    position: relative;
    width: 100%;
    height: 40%;
    background-image: url(../../assets/img/bigScreen/left_bottom.png);
    background-size: 100% 100%;
    margin: 0 0px 1% 0;
    color: #fff;
    float: left;
    padding-right: 10px;
    box-sizing: border-box;
  }

  .linear-gradient-text {
    background: linear-gradient(to bottom, #ffffff 25.53%, #66b1ff 84.52%);
    transition: all 0.5s;
    transition-timing-function: ease;
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    display: inline-block;
    font-weight: bold;
    font-size: 14px;
    display: flex;
    align-items: center;
  }
</style>
